<template>
  <PageLayout>
    <template #main>
      <h2 class="text-h3 font-weight-bold navy--text text--darken-1 pb-2">
        Zadejte svůj e-mail
      </h2>
      <p class="body-2 navy--text text--darken-1 pb-8">
        Na ten vám zašleme odkaz pro vytvoření nového hesla
      </p>

      <v-form
        v-model="valid"
        autocomplete="off"
        class="pb-6"
        ref="forgotPwForm"
      >
        <v-text-field
          v-model="email"
          label="E-mail"
          outlined
          :rules="emailRules"
          name="user-email"
          type="email"
          @input="validate"
        ></v-text-field>

        <v-alert
          v-if="apiResponseState.status === 200"
          type="success"
          outlined
          text
          class="mb-4"
        >
          <div>
            Na Vámi zadanou e-mailovou adresu byly odeslány instrukce k obnově
            hesla.
          </div>
        </v-alert>

        <v-alert
          v-if="apiResponseState.status > 200"
          type="error"
          outlined
          text
          class="mb-4"
        >
          <div v-if="apiResponseState.status === 404">
            Vámi zadaná e-mailová adresa nebyla nalezena. Zkontrolujte zadanou
            adresu.
          </div>
          <div v-else>
            Něco se pokazilo
          </div>
        </v-alert>
      </v-form>

      <div class="text-center pb-10">
        <v-btn
          color="primary"
          class="c-btn"
          :disabled="!valid"
          :loading="appResetPasswordPending"
          @click="onSendClick"
        >
          Odeslat e-mail
        </v-btn>
      </div>

      <div class="text-center pb-8">
        <router-link to="login" class="link link-underline navy--text">
          Zpět k přihlášení
        </router-link>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { call, get } from "vuex-pathify"

import PageLayout from "@/components/page/auth/PageLayout.vue"

export default {
  name: "ResetPassword",
  components: {
    PageLayout,
  },
  data() {
    return {
      valid: false,
      email: "",
      emailRules: [
        v => !!v || "E-mail je povinný",
        v => /.+@.+\..+/.test(v) || "Špatný tvar e-mailu.",
      ],
    }
  },
  computed: {
    ...get("app", ["apiResponseState"]),
    ...get("auth", ["appResetPasswordPending"]),
  },
  methods: {
    ...call("app", ["resetApiResponseState"]),
    ...call("auth", ["resetPassword"]),

    onSendClick() {
      if (this.valid) {
        this.resetPassword(this.email)
      }
    },

    validate() {
      this.$refs.forgotPwForm.validate()
    },
  },
  mounted() {
    this.resetApiResponseState()
  },
}
</script>
